import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
export function ContactForm() {
  const [step, setStep] = useState<1 | 2>(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
    }, 1200);
  };
  if (isSubmitted) {
    return <div className="bg-surface p-8 md:p-12 border border-gold/20 text-center" id="consultation" data-id="element-53">
        <div className="w-14 h-14 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-54">
          <CheckCircle2Icon className="w-7 h-7 text-gold" strokeWidth={1.5} data-id="element-55" />
        </div>
        <h3 className="font-serif text-3xl text-primary mb-3" data-id="element-56">Thank you.</h3>
        <p className="text-secondary leading-relaxed max-w-sm mx-auto" data-id="element-57">
          James or one of our jewellers will be in touch within one working day.
          If it's urgent, you're always welcome to call the workshop directly on{' '}
          <a href="tel:0893162321" className="text-gold-dark font-medium hover:underline" data-id="element-58">
            08 9316 2321
          </a>
          .
        </p>
      </div>;
  }
  return <div className="bg-surface p-8 md:p-10 border border-gold/20 shadow-[0_30px_80px_-20px_rgba(28,42,57,0.15)]" id="consultation" data-id="element-59">
      <div className="mb-7" data-id="element-60">
        <span className="eyebrow" data-id="element-61">Speak with James</span>
        <h3 className="font-serif text-2xl md:text-3xl text-primary leading-snug mb-2" data-id="element-62">
          Send us a quiet message.
        </h3>
        <p className="text-sm text-secondary leading-relaxed" data-id="element-63">
          Three quick fields. No sales call. We'll reply within one working day.
        </p>
      </div>

      {/* Step indicator */}
      <div className="flex items-center gap-2 mb-7" data-id="element-64">
        <div className={`flex items-center gap-2 text-xs ${step >= 1 ? 'text-primary' : 'text-muted'}`} data-id="element-65">
          <div className={`w-6 h-6 rounded-full flex items-center justify-center text-[0.65rem] font-medium ${step >= 1 ? 'bg-gold text-white' : 'bg-paper text-muted'}`} data-id="element-66">
            1
          </div>
          <span className="tracking-wider uppercase" data-id="element-67">Your details</span>
        </div>
        <div className={`h-px flex-1 ${step >= 2 ? 'bg-gold' : 'bg-gold/20'}`} data-id="element-68" />
        <div className={`flex items-center gap-2 text-xs ${step >= 2 ? 'text-primary' : 'text-muted'}`} data-id="element-69">
          <div className={`w-6 h-6 rounded-full flex items-center justify-center text-[0.65rem] font-medium ${step >= 2 ? 'bg-gold text-white' : 'bg-paper text-muted'}`} data-id="element-70">
            2
          </div>
          <span className="tracking-wider uppercase" data-id="element-71">Anything else</span>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5" data-id="element-72">
        <AnimatePresence mode="wait" data-id="element-73">
          {step === 1 && <motion.div key="step1" initial={{
          opacity: 0,
          x: -10
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: 10
        }} transition={{
          duration: 0.25
        }} className="space-y-5" data-id="element-74">
              <div data-id="element-75">
                <label htmlFor="name" className="block text-[0.65rem] font-semibold text-muted uppercase tracking-[0.18em] mb-2" data-id="element-76">
                  Your name
                </label>
                <input type="text" id="name" required className="w-full bg-paper border border-gold/20 px-4 py-3 text-sm focus:outline-none focus:border-gold focus:bg-background transition-colors" data-id="element-77" />
              </div>
              <div data-id="element-78">
                <label htmlFor="phone" className="block text-[0.65rem] font-semibold text-muted uppercase tracking-[0.18em] mb-2" data-id="element-79">
                  Phone number
                </label>
                <input type="tel" id="phone" required className="w-full bg-paper border border-gold/20 px-4 py-3 text-sm focus:outline-none focus:border-gold focus:bg-background transition-colors" data-id="element-80" />
              </div>
              <div data-id="element-81">
                <label htmlFor="service" className="block text-[0.65rem] font-semibold text-muted uppercase tracking-[0.18em] mb-2" data-id="element-82">
                  What's this about?
                </label>
                <select id="service" required className="w-full bg-paper border border-gold/20 px-4 py-3 text-sm focus:outline-none focus:border-gold focus:bg-background transition-colors appearance-none" data-id="element-83">
                  <option value="" data-id="element-84">Choose one...</option>
                  <option value="engagement" data-id="element-85">An engagement ring</option>
                  <option value="custom" data-id="element-86">A custom piece</option>
                  <option value="remodelling" data-id="element-87">Remodelling an heirloom</option>
                  <option value="repair" data-id="element-88">A repair or restoration</option>
                  <option value="diamond" data-id="element-89">Choosing a diamond</option>
                  <option value="valuation" data-id="element-90">A valuation</option>
                  <option value="other" data-id="element-91">Something else</option>
                </select>
              </div>

              <button type="button" onClick={() => setStep(2)} className="w-full btn-primary group" data-id="element-92">
                Continue
                <ArrowRightIcon className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-93" />
              </button>
            </motion.div>}

          {step === 2 && <motion.div key="step2" initial={{
          opacity: 0,
          x: 10
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -10
        }} transition={{
          duration: 0.25
        }} className="space-y-5" data-id="element-94">
              <div data-id="element-95">
                <label htmlFor="email" className="block text-[0.65rem] font-semibold text-muted uppercase tracking-[0.18em] mb-2" data-id="element-96">
                  Email{' '}
                  <span className="text-muted/60 font-normal normal-case" data-id="element-97">
                    (optional)
                  </span>
                </label>
                <input type="email" id="email" className="w-full bg-paper border border-gold/20 px-4 py-3 text-sm focus:outline-none focus:border-gold focus:bg-background transition-colors" data-id="element-98" />
              </div>
              <div data-id="element-99">
                <label htmlFor="timeframe" className="block text-[0.65rem] font-semibold text-muted uppercase tracking-[0.18em] mb-2" data-id="element-100">
                  Timeframe{' '}
                  <span className="text-muted/60 font-normal normal-case" data-id="element-101">
                    (optional)
                  </span>
                </label>
                <select id="timeframe" className="w-full bg-paper border border-gold/20 px-4 py-3 text-sm focus:outline-none focus:border-gold focus:bg-background transition-colors appearance-none" data-id="element-102">
                  <option value="" data-id="element-103">No rush — when's right is right</option>
                  <option value="asap" data-id="element-104">As soon as possible</option>
                  <option value="1-2-weeks" data-id="element-105">In the next 1–2 weeks</option>
                  <option value="1-3-months" data-id="element-106">Within 1–3 months</option>
                  <option value="researching" data-id="element-107">Just researching for now</option>
                </select>
              </div>
              <div data-id="element-108">
                <label htmlFor="message" className="block text-[0.65rem] font-semibold text-muted uppercase tracking-[0.18em] mb-2" data-id="element-109">
                  Anything else you'd like us to know?{' '}
                  <span className="text-muted/60 font-normal normal-case" data-id="element-110">
                    (optional)
                  </span>
                </label>
                <textarea id="message" rows={4} className="w-full bg-paper border border-gold/20 px-4 py-3 text-sm focus:outline-none focus:border-gold focus:bg-background transition-colors resize-none" placeholder="Inspiration, budget, a story behind the piece..." data-id="element-111" />
              </div>

              <div className="flex gap-3" data-id="element-112">
                <button type="button" onClick={() => setStep(1)} className="btn-secondary px-5" data-id="element-113">
                  Back
                </button>
                <button type="submit" disabled={isSubmitting} className="flex-1 btn-primary group" data-id="element-114">
                  {isSubmitting ? 'Sending...' : <>
                      Send to James
                      <ArrowRightIcon className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-115" />
                    </>}
                </button>
              </div>
            </motion.div>}
        </AnimatePresence>

        <p className="text-[0.65rem] text-muted leading-relaxed pt-3 border-t border-gold/10" data-id="element-116">
          We reply personally — never with an automated follow-up sequence. Your
          details stay with us.
          <span className="block mt-1.5 italic" data-id="element-117">
            [Bricks note: add file upload for inspiration photos in builder]
          </span>
        </p>
      </form>
    </div>;
}